import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { APP_VERSION } from '../lib/appVersion';
import { filterSentryEvent, SENTRY_DENIED_URLS, SENTRY_IGNORED_ERRORS } from './sentryFilters';

export function buildSentryOptions(
  dsn: string,
  environment: string,
): Sentry.BrowserOptions {
  return {
    dsn,
    // Backend (BeetegreVersion.Current) ile AYNI string: bir deploy'un iki yarisi Sentry'de tek
    // release altinda toplansin diye. Bkz. src/lib/appVersion.ts
    release: APP_VERSION,
    environment,
    // Sentry Logs: product events (print_template.printed) are queryable without opening issues.
    enableLogs: true,
    ignoreErrors: [...SENTRY_IGNORED_ERRORS],
    denyUrls: [...SENTRY_DENIED_URLS],
    beforeSend: filterSentryEvent,
    // Names transactions by the matched route pattern (`/orders/:id`) instead of the raw URL, so
    // each page is one transaction group. Needs App's `SentryRoutes`, see sentryBootstrap.ts.
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    // Kept low to avoid quota burn; raise after collecting a baseline.
    tracesSampleRate: 0.1,
  };
}

export function initSentry(dsn: string, environment: string): void {
  Sentry.init(buildSentryOptions(dsn, environment));
}
